import React, { Component } from 'react';
import { Container } from 'flux/utils';
import { Card, CardActions, CardHeader } from 'material-ui/Card';
import Divider from 'material-ui/Divider';
import FlatButton from 'material-ui/FlatButton';
import ResourceIcon from 'material-ui/svg-icons/av/library-books';
import { Link } from 'react-router';

import { StatTypes } from '../../constants/CentricConstants';
import { statusColours } from '../../constants/ColourConstants';
import StatStore from '../../stores/StatStore';
import ModuleActions from '../../actions/ModuleActionCreator';

const ResourceWidget = ({resources}) => (
    <Card className="cent-card" initiallyExpanded={true} >
        <CardHeader
            title={<Link to="/dashboard/modules/resource" >Resources</Link>}
            subtitle={resources ? `${resources} resources` : ' '}
            avatar={<Link to="/dashboard/modules/resource" ><ResourceIcon color={statusColours.default} /></Link>}
        />
        <Divider />
        <CardActions>
            <FlatButton
                key="findMedia"
                label="Search Title"
                href="/dashboard/modules/resource/search"
            />
            <FlatButton
                key="searchMedia"
                label="Search Content"
                href="/dashboard/modules/resource/search/content"
            />
        </CardActions>

    </Card>
);

class ResourceWidgetContainer extends Component {
    componentDidMount() {
        ModuleActions.getResourceCount();
    }

    render() {
        return (<ResourceWidget {...this.state} />);
    }
}

ResourceWidgetContainer.getStores = () => ([StatStore]);
ResourceWidgetContainer.calculateState = (prevState = {}) => ({
    ...prevState,
    resources:      Number(StatStore.get(StatTypes.RESOURCE_COUNT)) || 0,
});

export default Container.create(ResourceWidgetContainer);
